import { sendAnalyticsEvent } from 'analytics/analytics';
import config from 'config';
import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  getToken,
  onMessage,
  deleteToken,
} from 'firebase/messaging';

const firebaseConfig = {
  apiKey: config.firebaseApiKey,
  authDomain: config.firebaseAuthDomain,
  projectId: config.firebaseProjectId,
  storageBucket: config.firebaseStorageBucket,
  messagingSenderId: config.firebaseSenderId,
  appId: config.firebaseAppId,
  measurementId: config.firebaseMeasurementId,
};
initializeApp(firebaseConfig);
const messaging = getMessaging();

export const requestForToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_ID,
    });
    if (currentToken) {
      sendAnalyticsEvent('FCM token received', {
        token: currentToken,
      });
      return {
        token: currentToken,
      };
    } else {
      console.log('No token found');
    }
  } catch (err) {
    console.log('Error occurred', err);
    sendAnalyticsEvent('FCM token error', {
      error: err,
    });
  }
};

onMessage(messaging, (payload) => {
  const audioUrl = payload && payload.data && payload.data.notificationSoundUrl;
  try {
    let audio = new Audio(audioUrl);
    audio.play();
    sendAnalyticsEvent('Notification Sound played', {
      payload: payload,
    });
  } catch (err) {
    sendAnalyticsEvent('Notification error', {
      error: err,
    });
  }
});

export const removeFcmToken = () => {
  deleteToken(messaging)
    .then(() => {
      sendAnalyticsEvent('FCM Token deleted', {
        message: 'Token deletion successfull!',
      });
    })
    .catch((error) => {
      sendAnalyticsEvent('ERR:FCM token deletion', {
        error: error,
      });
    });
};
